import React, { useEffect, useState } from 'react'; // , { useEffect, useState }
import { useHistory } from 'react-router-dom';
import useTranslation from '../../hooks/useTranslation';
import EpButton from '../../components/EpButton';
import EpimedLogo from '../../assets/img/Logo_Epimed.svg';
// import { SHARED_ERROR_MESSAGE_404 } from '../../constants/sharedErrorConstants';
import './styles.scss';

const SharedError = () => {
  // Tags do Globalization
  const BackToHomePage = useTranslation('Back to home page');

  const history = useHistory();
  const [statusCode, setStatusCode] = useState('');
  // const [message, setMessage] = useState(SHARED_ERROR_MESSAGE_404);

  useEffect(() => {
    if (window.history.state.state) {
      setStatusCode(window.history.state.state.code);
      // setMessage(window.history.state.state.message);
    } else {
      setStatusCode(404);
    }
  }, []);

  return (
    <>
      <header id="navigation--simple-header">
        <div className="container">
          <div className="navigation__brand-logo">
            <img
              className="navigation__brand-logo-image"
              src={EpimedLogo}
              alt="Epimed logo"
            />
          </div>
        </div>
      </header>

      <div className="error-page__main-content">
        <h1 className="error-page__status-code">{statusCode}</h1>
        {/* <p className="error-page__status-text">{message}</p> */}
        <EpButton type="button" labelText={BackToHomePage} linkFunc={() => history.push('/')} buttonType="primary-outline" disabled={false} />
      </div>
    </>
  );
};

export default SharedError;
